import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export type VendorListPersonnelFromTab = 'all' | 'vendor' | 'activity';

export class VendorListPersonnelRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  getCreateRoute(): string {
    return PathUtility.VendorListPersonnelCreate();
  }

  getEditRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const fromTab: VendorListPersonnelFromTab =
      this.parameters['fromTab'] || 'vendor';
    return `${PathUtility.VendorListPersonnelEdit(id, view)}?from=${fromTab}`;
  }

  getViewRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const fromTab: VendorListPersonnelFromTab =
      this.parameters['fromTab'] || 'vendor';
    return `${PathUtility.VendorListPersonnelView(id, view)}?from=${fromTab}`;
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    const fromTab: VendorListPersonnelFromTab =
      this.parameters['fromTab'] || 'vendor';
    if (fromTab === 'all' || fromTab === 'activity') {
      return PathUtility.Personnel(fromTab);
    }
    return PathUtility.Vendors('personnel');
  }
}
